import { useResourcePermissionsByCurrentUser } from '../components/context/getDisabledActionsReasons.js';
import { isResourceDetailBookmark } from '../../resources/utils/resourceDetailGuards.js';
import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';

const useScrapeRefresh = (resource) => {
  const { client } = useWoody();
  const permission = useResourcePermissionsByCurrentUser(resource);
  const { mutate } = useMutation({
    mutationFn: () => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/link-preview/force",
        params: {
          resourceId: resource.id
        }
      }, {
        method: "post"
      });
    },
    onSuccess: () => {
      toast({
        content: "Refreshing URL preview"
      });
    }
  });
  const isBookmark = isResourceDetailBookmark(resource);
  return useMemo(() => {
    const isValidResource = isBookmark;
    const hasPermission = permission.permissions.resource.edit;
    if (!isValidResource || !hasPermission || resource.isDraft) {
      return {
        canRefreshScrape: false,
        refreshScrape: void 0
      };
    }
    return {
      canRefreshScrape: true,
      refreshScrape: () => mutate()
    };
  }, [
    isBookmark,
    resource.isDraft,
    mutate,
    permission.permissions.resource.edit
  ]);
};

export { useScrapeRefresh };
//# sourceMappingURL=useScrapeRefresh.js.map
